module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-9"
  }, [_c('player-report')], 1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "small-segment"
  }, [_c('player-table', {
    attrs: {
      "heading": "Cardiff Devils",
      "tableData": _vm.clean,
      "headings": ['#', ''],
      "redirect": "/season-stats/player-stats/"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a4a4d57"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/stats/season-stats/player-season-stats.vue
// module id = 624
// module chunks = 30